$(function() {

    // @vars
    // ---------------------------------------------------------------------------------------------------------------------
    var
        $location,
        $geolocation,
        autocomplete,
        geocoder,
        location;

    // @initializations
    // ---------------------------------------------------------------------------------------------------------------------
    $location = $('#location');
    $geolocation = $('#geolocation');
    location = $location.get(0);

    if (typeof location === 'undefined') {
        return;
    }

    autocomplete = new google.maps.places.Autocomplete(location, { types: ['(regions)'] });
    geocoder = new google.maps.Geocoder();

    // @functions
    // ---------------------------------------------------------------------------------------------------------------------
    function sendData(data) {
        return $.ajax({
            url: CCM_REL + '/index.php/tools/packages/calendar/ajax.php',
            data: data,
            type: 'GET',
            dataType: 'json'
        });
    }

    // @events
    // -----------------------------------------------------------------------------------------------------------------
    google.maps.event.addListener(autocomplete, 'place_changed', function() {
        $('.form-region-select').submit();
    });

    $geolocation.on('click', function(eventObj) {
        eventObj.preventDefault();
        if (typeof navigator.geolocation !== 'undefined') {
            navigator.geolocation.getCurrentPosition(function(position) {
                sendData({
                    action: 'session-store-geolocation',
                    position: position.coords
                }).done(window.location.reload());
            }, function() {
                alert('Sorry, no position available')
            }, {
                enableHighAccuracy: true,
                maximumAge: 30000,
                timeout: 27000
            });
        }
    });

    $(document).on('submit', '.form-region-select', function(eventObj) {
        eventObj.preventDefault();
        geocoder.geocode({
            'address': $location.val()
        }, function(results, status) {
            if (google.maps.GeocoderStatus.OK === status) {
                for (var i in results[0].address_components) {
                    if ('country' === results[0].address_components[i].types[0]) {
                        sendData({
                            action: 'session-store-country',
                            location: $('#location').val(),
                            country: results[0].address_components[i].short_name
                        }).done(window.location.reload());
                    }
                }
            }
        });
    });
});
